import { acceptHMRUpdate, defineStore } from "pinia";
import { computed, ref } from "vue";

export const useDatasourceStore = defineStore("datasource", () => {
  const isTestDatasource = ref(true);

  const sourceName = computed(() => (isTestDatasource.value ? "test" : "train"));

  return { isTestDatasource, sourceName };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDatasourceStore, import.meta.hot));
}
